import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    minWidth: 600
  },
  modalHeader: {
    marginBottom: theme.spacing(6)
  },
  modalContent: {
    marginBottom: theme.spacing(6)
  },
  content: {
    marginBottom: theme.spacing(3)
  },
  documentsCard: {
    padding: theme.spacing(3)
  },
  uploadContainer: {
    minHeight: 200
  },
  supportText: {
    marginTop: theme.spacing(2)
  },
  supportedFormats: {
    color: theme.palette.text.secondary,
    fontSize: '0.875rem'
  },
  modalActions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(2)
  },
  noDocsMessage: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(6)
  },
  link: {
    color: theme.colorPalette.orange_50,
    textDecoration: 'underline',
    cursor: 'pointer',
    padding: '0 4px'
  },
  existingFilesHeader: {
    marginBottom: theme.spacing(2)
  },
  table: {
    width: '100%',
    marginBottom: theme.spacing(3),
    '& td, th': {
      padding: '8px 16px'
    }
  },
  headerCell: {
    fontWeight: 600,
    fontSize: '0.75rem',
    color: theme.palette.text.secondary,
    textTransform: 'uppercase',
    letterSpacing: '0.5px'
  },
  tableRow: {
    '&:hover': {
      backgroundColor: theme.palette.action.hover
    },
    height: 60
  },
  fileName: {
    color: theme.colors.green_80
  },
  fileNameCell: {
    maxWidth: 300
  },
  fileNameContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1)
  },
  actionsCell: {
    width: 100
  },
  actions: {
    display: 'flex',
    gap: theme.spacing(0.5)
  },
  actionButton: {
    padding: theme.spacing(0.5),
    '&:hover': {
      backgroundColor: theme.palette.action.hover
    }
  },
  uploadMoreLabel: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  deleteButton: {
    '&:hover': {
      backgroundColor: theme.palette.action.hover
    },
    '& img': {
      width: 25,
      height: 25
    }
  },
  deleteSpinner: {
    color: theme.colorPalette.orange_50
  }
}));

export default useStyles;
